import React, { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { GetOrderDetailsById } from "../Api/Queries";
import { ScaleLoader } from "react-spinners";
import { useSearchParams } from "react-router-dom";

const TrackOrder = () => {
  const [orderId, setOrderId] = useState("");
  const [orderDeatils, setOrderDetails] = useState(null);
  const [dataFetching, setDataFetching] = useState(false);
  const [detailsFetched, setDetailsFetched] = useState(false);
  const [searchParams] = useSearchParams();
  const oid = searchParams.get("orderId");

  const fetchOrderDeatils = async (oid) => {
    setDataFetching(true);
    try {
      await GetOrderDetailsById(oid, setOrderDetails);
    } catch (error) {
      toast.error("Something Went Wrong");
    } finally {
      setDataFetching(false);
      setDetailsFetched(true);
    }
  };

  useEffect(() => {
    if (!oid) return;

    setOrderId(oid);
    fetchOrderDeatils(oid);
  }, [oid]);

  const handleChange = (e) => {
    setDetailsFetched(false);
    setOrderId(e.target.value);
  };

  const handleSearch = async () => {
    if (orderId === "") {
      toast.error("Please Enter Order Id");
      return;
    } else {
      fetchOrderDeatils(orderId);
    }
  };

  console.log(orderId !== "");
  return (
    <>
      <div id="qodef-page-inner" className="qodef-content-grid">
        <main
          id="qodef-page-content"
          className="qodef-grid qodef-layout--template"
        >
          <div className="qodef-grid-inner clear">
            <div className="qodef-grid-item qodef-page-content-section qodef-col--12">
              <div className="woocommerce">
                <div className="woocommerce-notices-wrapper" />
                <div id="qodef-woo-page" className="qodef--checkout">
                  <div className="col2-set" id="customer_details">
                    <div className="col-1">
                      <div className="woocommerce-billing-fields">
                        <h3>Order Status</h3>
                        <p className="form-row form-row-first validate-required">
                          <label>Order Id *</label>
                          <input
                            type="text"
                            name="firstName"
                            onChange={handleChange}
                            required
                          />
                        </p>

                        <button
                          className="button alt qodef-borders--added"
                          name="woocommerce_checkout_place_order"
                          onClick={handleSearch}
                        >
                          Search Order
                        </button>
                      </div>
                      {dataFetching ? (
                        <>
                          <center>
                            <ScaleLoader color="#241c10" />
                            <p>Loading Order Details....</p>
                          </center>
                        </>
                      ) : (
                        <>
                          {orderDeatils !== null ? (
                            <>
                              <div>
                                <br />
                                <h3>Order Details</h3>
                                <p style={{ display: "flex" }}>
                                  Order For: &nbsp;
                                  <span>{orderDeatils[0].userName}</span>
                                </p>
                                <p style={{ display: "flex" }}>
                                  Customer Email: &nbsp;
                                  <span>{orderDeatils[0].email}</span>
                                </p>
                                <p style={{ display: "flex" }}>
                                  Customer Phone: &nbsp;
                                  <span>{orderDeatils[0].phone}</span>
                                </p>
                                <p style={{ display: "flex" }}>
                                  Delivery Address: &nbsp;
                                  <span>{orderDeatils[0].address}</span>
                                </p>
                                {orderDeatils[0].paymentStatus === "paid" ? (
                                  <p style={{ display: "flex" }}>
                                    Payment ID: &nbsp;
                                    <span>{orderDeatils[0].paymentId}</span>
                                  </p>
                                ) : (
                                  <></>
                                )}

                                <p style={{ display: "flex" }}>
                                  Order Status: &nbsp;
                                  <span>{orderDeatils[0].orderStatus}</span>
                                </p>
                                {orderDeatils[0].orderStatus !==
                                "processing" ? (
                                  <p style={{ display: "flex" }}>
                                    Order Shipping Link: &nbsp;
                                    <span>
                                      <a
                                        href={orderDeatils[0]?.shippingLink}
                                        target="_blank"
                                        rel="noreferrer"
                                      >
                                        {orderDeatils[0]?.shippingLink ||
                                          "Not Available"}
                                      </a>
                                    </span>
                                  </p>
                                ) : (
                                  <></>
                                )}
                                <p style={{ display: "flex" }}>
                                  Order Date: &nbsp;
                                  <span>
                                    {new Date(
                                      orderDeatils[0].createdAt
                                    ).toLocaleDateString("en-IN")}
                                  </span>
                                </p>

                                <p style={{ display: "flex" }}>
                                  Product Name: &nbsp;
                                  <span>{orderDeatils[0].productName}</span>
                                </p>
                                <p style={{ display: "flex" }}>
                                  Order Quantity: &nbsp;
                                  <span>{orderDeatils[0].quantity}</span>
                                </p>
                                <p style={{ display: "flex" }}>
                                  Payment Status: &nbsp;
                                  <span>
                                    {orderDeatils[0].paymentStatus}{" "}
                                    {orderDeatils[0].paymentStatus === "pending"
                                      ? "❌"
                                      : "✅"}
                                  </span>
                                </p>
                              </div>
                            </>
                          ) : (
                            <>
                              {orderId !== "" &&
                              detailsFetched &&
                              orderDeatils == null ? (
                                <>
                                  &nbsp;
                                  <center>
                                    <img
                                      src="https://res.cloudinary.com/dgne9mq7j/image/upload/v1744981081/image_on2qrl.webp"
                                      style={{ maxHeight: "400px" }}
                                      alt="no_order_found"
                                    />
                                  </center>
                                </>
                              ) : (
                                <></>
                              )}
                            </>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>

      <Toaster />
    </>
  );
};

export default TrackOrder;
